/**
 * QUOTATION SLICE — stato del preventivo core.
 *
 * ## Perché la chiave è `quotations` e non `quotations`
 *
 * `store.ts` compone i reducer come `{...coreReducers, ...pluginReducers}`: a
 * parità di chiave **vince il plugin**, in silenzio. Finché il preventivo resta
 * anche in un plugin, la chiave `quotations` è occupata — e `pluginLoader`
 * registra i reducer di ogni plugin trovato dalla glob anche quando è
 * disabilitato, quindi non esiste un interruttore che la liberi.
 *
 * Il nome definitivo arriva allo step 12 di TS-87, quando il preventivo esce
 * dal plugin che lo ospitava. Vedi la decisione D11 in PLAN-TS-87.md: lo stesso
 * vale per il prefisso degli action type (`quotationThunks.ts`) e per il
 * prefisso delle rotte.
 */

import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { quotationThunks } from './quotationThunks';
import type { QuotationState } from './quotationTypes';

const initialState: QuotationState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

export const quotationSlice = createSlice({
  name: 'quotations',
  initialState,
  reducers: {
    clearCurrentQuotation(state) {
      state.currentItem = null;
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, quotationThunks, (q) => q.quotationId);
  },
});

export const { clearCurrentQuotation } = quotationSlice.actions;
export const quotationReducer = quotationSlice.reducer;
